/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";

function TimelineImage (props) {
    
    const { image } = props;
    const width = 200;
    const { alt, title, url } = image || {};

    return (
        <Fragment>
            {image && (
                <div className='timeline-image-container'>
                    <img
                        alt={alt}
                        title={title}
                        width={width}
                        src={url}
                    />
                </div>
            )}
        </Fragment>
    );
}

export { TimelineImage };
